import {BrowserModule} from '@angular/platform-browser';
import {CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule} from '@angular/core';

import {AppComponent} from './app.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {HttpInterceptor} from "./core/interceptors/http.interceptor";
import {RoutingModule} from "./core/modules/routing.module";
import {PagesModule} from "./pages/pages.module";
import {CoreModule} from "./core/core.module";
import {NgxSpinnerModule} from "ngx-spinner";
import {NotifierModule, NotifierOptions} from "angular-notifier";
import {MAT_CHECKBOX_CLICK_ACTION} from "@angular/material";
import 'hammerjs';
import {registerLocaleData} from '@angular/common';
import ptBr from '@angular/common/locales/br';
import ptBrExtra from '@angular/common/locales/extra/br';
import {DevComponent} from "./dev-component";

@NgModule({
	declarations: [
		AppComponent,
		DevComponent
	],
	imports: [
		BrowserModule,
		HttpClientModule,
		RoutingModule,
		PagesModule,
		CoreModule,
		NgxSpinnerModule,
		NotifierModule.withConfig(AppModule.CUSTOM_NOTIFIER_CONFIG)
	],
	providers: [
		// {provide: HTTP_INTERCEPTORS, useClass: ProgressInterceptor, multi: true, deps: [ProgressBarService]},
		{provide: HTTP_INTERCEPTORS, useClass: HttpInterceptor, multi: true},
		{provide: MAT_CHECKBOX_CLICK_ACTION, useValue: 'check'},
		{provide: LOCALE_ID, useValue: "pt-BR"}

	],
	bootstrap: [AppComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class AppModule {
	static CUSTOM_NOTIFIER_CONFIG: NotifierOptions = {
		position: {
			horizontal: { position: 'middle', distance: 20 },
			vertical: { position: 'top', distance: 70, gap: 10 }
		},
		theme: 'material',
		behaviour: { autoHide: 5000, onClick: 'hide', onMouseover: 'pauseAutoHide', showDismissButton: true, stacking: 10 },
		animations: {
			enabled: true,
			show: { preset: 'slide', speed: 300, easing: 'ease' },
			hide: { preset: 'fade', speed: 300, easing: 'ease', offset: 50 },
			shift: { speed: 300, easing: 'ease' },
			overlap: 150
		}
	}

	public constructor(){
		registerLocaleData(ptBr, 'pt-BR', ptBrExtra);
	}
}
